export function shouldEnableSelection(dimensionCode: string | undefined): boolean {
  return dimensionCode === 'by_product' || dimensionCode === 'by_variant';
}
